// ABAY360 Phase 1 demo data (frontend-only, realistic sample listings).
// In future phases this is replaced by Supabase / API data.

export const NAV_ITEMS = [
  { label: 'Buy', to: '/buy' },
  { label: 'Rent', to: '/rent' },
  { label: 'Land', to: '/land' },
  { label: 'Commercial', to: '/commercial' },
  { label: 'New Projects', to: '/new-projects' },
  { label: 'Invest', to: '/invest' },
  { label: 'Agents', to: '/agents' },
  { label: 'Blog', to: '/blog' },
  { label: 'About', to: '/about' },
];

export const CATEGORIES = [
  { key: 'buy', title: 'Buy', desc: 'Own your dream home', icon: 'Home', to: '/buy', count: '4,280+ homes' },
  { key: 'rent', title: 'Rent', desc: 'Flexible living spaces', icon: 'KeyRound', to: '/rent', count: '2,140+ rentals' },
  { key: 'land', title: 'Land', desc: 'Prime plots & farms', icon: 'Globe2', to: '/land', count: '860+ plots' },
  { key: 'commercial', title: 'Commercial', desc: 'Offices & retail', icon: 'Building2', to: '/commercial', count: '540+ spaces' },
  { key: 'new-projects', title: 'New Projects', desc: 'Off-plan developments', icon: 'Hammer', to: '/new-projects', count: '120+ projects' },
  { key: 'investment', title: 'Investment', desc: 'High-yield assets', icon: 'TrendingUp', to: '/invest', count: 'ROI up to 18%' },
];

export const PROPERTIES = [
  {
    id: 'ABY-1001',
    title: 'Modern 4-Bedroom Villa',
    type: 'Luxury Home',
    deal: 'For Sale',
    price: 24500000,
    currency: 'ETB',
    beds: 4,
    baths: 5,
    sqm: 420,
    location: 'Bole, Addis Ababa',
    lat: 8.9959,
    lng: 38.7896,
    aiScore: 94,
    verified: true,
    image: 'https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwbW9kZXJufGVufDB8fHx8MTc4MzAyODAwNXww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'ABY-1002',
    title: 'Skyline Penthouse Apartment',
    type: 'Apartment',
    deal: 'For Sale',
    price: 18900000,
    currency: 'ETB',
    beds: 3,
    baths: 3,
    sqm: 240,
    location: 'Kazanchis, Addis Ababa',
    lat: 9.0125,
    lng: 38.7614,
    aiScore: 91,
    verified: true,
    image: 'https://images.unsplash.com/photo-1665249934445-1de680641f50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMGJyaWdodHxlbnwwfHx8fDE3ODMwMjgwMTB8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'ABY-1003',
    title: 'Contemporary Family House',
    type: 'Luxury Home',
    deal: 'For Sale',
    price: 15200000,
    currency: 'ETB',
    beds: 5,
    baths: 4,
    sqm: 360,
    location: 'CMC, Addis Ababa',
    lat: 9.0187,
    lng: 38.8452,
    aiScore: 88,
    verified: true,
    image: 'https://images.unsplash.com/photo-1622015663319-e97e697503ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwbW9kZXJufGVufDB8fHx8MTc4MzAyODAwNXww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'ABY-1004',
    title: 'Bright Studio for Rent',
    type: 'Apartment',
    deal: 'For Rent',
    price: 38000,
    currency: 'ETB',
    beds: 1,
    baths: 1,
    sqm: 68,
    location: 'Sarbet, Addis Ababa',
    lat: 8.9931,
    lng: 38.7469,
    aiScore: 82,
    verified: true,
    image: 'https://images.pexels.com/photos/8146330/pexels-photo-8146330.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'ABY-1005',
    title: 'Lakeside Investment Villa',
    type: 'Investment',
    deal: 'For Sale',
    price: 32000000,
    currency: 'ETB',
    beds: 6,
    baths: 6,
    sqm: 540,
    location: 'Hawassa, Sidama',
    lat: 7.0621,
    lng: 38.4776,
    aiScore: 96,
    verified: true,
    image: 'https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwbW9kZXJufGVufDB8fHx8MTc4MzAyODAwNXww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'ABY-1006',
    title: 'Downtown Office Floor',
    type: 'Commercial',
    deal: 'For Rent',
    price: 220000,
    currency: 'ETB',
    beds: 0,
    baths: 2,
    sqm: 310,
    location: 'Megenagna, Addis Ababa',
    lat: 9.0203,
    lng: 38.8000,
    aiScore: 85,
    verified: false,
    image: 'https://images.pexels.com/photos/8146330/pexels-photo-8146330.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'ABY-1007',
    title: 'Riverfront Development Plot',
    type: 'Land',
    deal: 'For Sale',
    price: 9800000,
    currency: 'ETB',
    beds: 0,
    baths: 0,
    sqm: 1200,
    location: 'Bahir Dar, Amhara',
    lat: 11.5936,
    lng: 37.3908,
    aiScore: 79,
    verified: true,
    image: 'https://images.unsplash.com/photo-1622015663319-e97e697503ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB2aWxsYSUyMGV4dGVyaW9yJTIwbW9kZXJufGVufDB8fHx8MTc4MzAyODAwNXww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'ABY-1008',
    title: 'Smart Apartment Residence',
    type: 'New Development',
    deal: 'Off-Plan',
    price: 12750000,
    currency: 'ETB',
    beds: 2,
    baths: 2,
    sqm: 145,
    location: 'Ayat, Addis Ababa',
    lat: 9.0361,
    lng: 38.8825,
    aiScore: 90,
    verified: true,
    image: 'https://images.unsplash.com/photo-1665249934445-1de680641f50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMGJyaWdodHxlbnwwfHx8fDE3ODMwMjgwMTB8MA&ixlib=rb-4.1.0&q=85',
  },
];

export const WHY_FEATURES = [
  { icon: 'BadgeCheck', title: 'Verified Listings', desc: 'Every property is verified by our team and trusted agents before it goes live.' },
  { icon: 'Sparkles', title: 'AI Search', desc: 'Describe your dream home in plain language and let Abay AI find the perfect match.' },
  { icon: 'Map', title: 'Interactive Maps', desc: 'Explore neighborhoods, landmarks and prices on a live map of Ethiopia.' },
  { icon: 'Calculator', title: 'Smart Mortgage & Affordability Tools', desc: 'Estimate monthly payments and what you can afford instantly, tailored to ETB.' },
  { icon: 'UserCheck', title: 'Trusted Agents', desc: 'Connect with rated, licensed agents across every major Ethiopian city.' },
  { icon: 'ShieldCheck', title: 'Secure Payments', desc: 'Bank-grade, escrow-ready transactions designed for safe property deals.' },
  { icon: 'LineChart', title: 'Market Insights', desc: 'Track prices, demand and ROI trends with data-driven market intelligence.' },
];

export const PROPERTY_TYPES = [
  { title: 'Luxury Homes', icon: 'Crown', to: '/buy' },
  { title: 'Apartments', icon: 'Building', to: '/rent' },
  { title: 'Land', icon: 'Globe2', to: '/land' },
  { title: 'Commercial', icon: 'Store', to: '/commercial' },
  { title: 'Office', icon: 'Briefcase', to: '/commercial' },
  { title: 'Investment Properties', icon: 'TrendingUp', to: '/invest' },
  { title: 'New Developments', icon: 'Hammer', to: '/new-projects' },
];

export const TESTIMONIALS = [
  {
    name: 'Meron Tadesse',
    role: 'Home Buyer',
    city: 'Bole, Addis Ababa',
    property: 'Bought a 4-bedroom villa',
    quote: 'ABAY360 made buying our first home effortless. The AI search understood exactly what our family needed.',
    avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NjYzMDF8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMGZhY2V8ZW58MHx8fHwxNzgzMDI4MDIwfDA&ixlib=rb-4.1.0&q=85',
    rating: 5,
  },
  {
    name: 'Dawit Bekele',
    role: 'Property Investor',
    city: 'Hawassa, Sidama',
    property: 'Invested in a lakeside villa',
    quote: 'The market insights and verified listings gave me confidence to invest in Hawassa. Best PropTech in Ethiopia.',
    avatar: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NjYzMDF8MHwxfHNlYXJjaHwyfHxwb3J0cmFpdCUyMGZhY2V8ZW58MHx8fHwxNzgzMDI4MDIwfDA&ixlib=rb-4.1.0&q=85',
    rating: 5,
  },
  {
    name: 'Hana Girma',
    role: 'Renter',
    city: 'Kazanchis, Addis Ababa',
    property: 'Rented a modern apartment',
    quote: 'I found a beautiful apartment in two days. The map browsing and interactive tour were a game changer.',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&w=200&q=80',
    rating: 4,
  },
  {
    name: 'Samuel Alemu',
    role: 'First-time Buyer',
    city: 'CMC, Addis Ababa',
    property: 'Bought a family townhouse',
    quote: 'The mortgage tools helped me understand exactly what I could afford before I even visited a property.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&w=200&q=80',
    rating: 5,
  },
  {
    name: 'Liya Haile',
    role: 'Home Seller',
    city: 'Summit, Addis Ababa',
    property: 'Sold a 3-bedroom home',
    quote: 'Listing was simple and I connected with serious, verified buyers within a week. Highly recommended.',
    avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?crop=entropy&cs=srgb&fm=jpg&w=200&q=80',
    rating: 5,
  },
];

export const AI_PROMPTS = [
  'Find homes',
  'Estimate property value',
  'Mortgage help',
  'Investment advice',
  'Neighborhood information',
];

export function formatPrice(value, currency = 'ETB') {
  if (value >= 1000000) {
    return `${currency} ${(value / 1000000).toFixed(value % 1000000 === 0 ? 0 : 1)}M`;
  }
  if (value >= 1000) {
    return `${currency} ${(value / 1000).toFixed(0)}K`;
  }
  return `${currency} ${value.toLocaleString()}`;
}
